export const BELGIUM_BOUNDS = {
  ne: { lat: 51.51, lng: 6.41 },
  sw: { lat: 49.49, lng: 2.54 },
};

export const isValidSearchMapBounds = bounds => {
  return !!(
    bounds?.ne &&
    bounds?.sw &&
    Number.isFinite(bounds?.ne?.lat) &&
    Number.isFinite(bounds?.ne?.lng) &&
    Number.isFinite(bounds?.sw?.lat) &&
    Number.isFinite(bounds?.sw?.lng)
  );
};

export const getSearchMapBounds = bounds => {
  return isValidSearchMapBounds(bounds) ? bounds : BELGIUM_BOUNDS;
};
